import React, { FC } from 'react';
import { JPrivacyProps } from './../../models';
import { JRadio } from './JRadio';


export const JPrivacy: FC<JPrivacyProps> = props => <JRadio {...props} />